import toPairs from "lodash/toPairs"
import get from "lodash/get"
import forEach from "lodash/forEach"
import axios from "axios"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"
import {
  SUBMIT_BULK_FORM_SELECTIONS_PENDING,
  SUBMIT_BULK_FORM_SELECTIONS_FULFILLED,
  SUBMIT_BULK_FORM_SELECTIONS_FAILED,
} from "constants-lib/actionTypes"

const pendingAC = () => ({
  type: SUBMIT_BULK_FORM_SELECTIONS_PENDING,
})
const failedAC = () => ({
  type: SUBMIT_BULK_FORM_SELECTIONS_FAILED,
})
const fulfilledAC = (data) => ({
  type: SUBMIT_BULK_FORM_SELECTIONS_FULFILLED,
  payload: data,
})

/**
 * Submits a bulk pickup form for Oakland service area, handling recaptcha verification and dispatching relevant actions.
 * @param {Object} params - The parameters for the bulk pickup form submission.
 * @param {Object} params.bulkFormSelections - User selections for the bulk pickup form.
 * @param {string} params.userId - Optional user ID, defaults to an empty string.
 * @param {string} params.lang - Language preference for the submission.
 * @param {string} params.recaptchaToken - Token for recaptcha verification.
 * @param {string} params.recaptchaAction - Action for recaptcha verification.
 * @returns {Function} Dispatches actions based on the submission result.
 */
export const submitOaklandBulkForm =
  ({
    bulkFormSelections,
    userId = "",
    lang,
    recaptchaToken,
    recaptchaAction,
  }) =>
  (dispatch) => {
    const {
      firstName,
      lastName,
      phone,
      email,
      address,
      zipCode,
      addressLine2,
      bulkPickupItems,
      pickupType,
      pickupDate,
    } = bulkFormSelections

    const formattedBulkPickupItems = []
    forEach(toPairs(bulkPickupItems), ([category, isIncluded]) => {
      isIncluded &&
        formattedBulkPickupItems.push({
          itemCategory: category,
        })
    })

    dispatch(pendingAC())

    const api = `SUBMIT_BULK_PICKUP`
    const apiKey = get(urls, `apiKey.GUEST[${api}]`, ``)

    const template = URITemplate(urls.url[api])

    const url = template.expand({
      userId,
      lang,
    })

    const config = {
      headers: {
        apiKey,
      },
    }

    const data = {
      request_type: `BULK_PICKUP`,
      product_type: `Bulk Item Pickup`,
      lob: `R`,
      contact_name: `${firstName} ${lastName}`,
      contact_phone: phone,
      contact_email: email,
      address: {
        street_address: address,
        apartment: addressLine2,
        postal_code: zipCode,
        state: `CA`, // leaving hard-coded as this flow is only for oakland
        city: `Oakland`, // leaving hard-coded as this flow is only for oakland
      },
      comments: ``,
      bulkPickup: formattedBulkPickupItems,
      pickupType,
      pickupDate,
      recaptchaToken,
      recaptchaAction,
    }

    return axios
      .create(config)
      .post(url, data)
      .then((response) => {
        dispatch(fulfilledAC(response.data))
        return response
      })
      .catch((e) => {
        dispatch(failedAC())
        return e
      })
  }
